var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _g2, _path8, _path9, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoTemplate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 138,
    viewBox: "0 0 114 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.9277 128.928C88.368 128.928 113.855 103.44 113.855 72C113.855 40.5597 88.368 15.0723 56.9277 15.0723C25.4874 15.0723 0 40.5597 0 72C0 103.44 25.4874 128.928 56.9277 128.928Z",
    fill: "#E6F0F0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_314_10786)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.5664 47.7109H24.2893C22.1933 47.7109 20.4941 49.4101 20.4941 51.5061V131.205C20.4941 133.301 22.1933 135 24.2893 135H89.5664C91.6624 135 93.3616 133.301 93.3616 131.205V51.5061C93.3616 49.4101 91.6624 47.7109 89.5664 47.7109Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3372 59.0962H29.6023C28.3447 59.0962 27.3252 60.1157 27.3252 61.3733C27.3252 62.6309 28.3447 63.6504 29.6023 63.6504H49.3372C50.5949 63.6504 51.6144 62.6309 51.6144 61.3733C51.6144 60.1157 50.5949 59.0962 49.3372 59.0962Z",
    fill: "#E6F0F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9999 68.9634H29.6023C28.3447 68.9634 27.3252 69.9829 27.3252 71.2405C27.3252 72.4981 28.3447 73.5176 29.6023 73.5176H62.9999C64.2575 73.5176 65.277 72.4981 65.277 71.2405C65.277 69.9829 64.2575 68.9634 62.9999 68.9634Z",
    fill: "#B3D1D1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3372 79.5903H29.6023C28.3447 79.5903 27.3252 80.6098 27.3252 81.8674C27.3252 83.1251 28.3447 84.1445 29.6023 84.1445H49.3372C50.5949 84.1445 51.6144 83.1251 51.6144 81.8674C51.6144 80.6098 50.5949 79.5903 49.3372 79.5903Z",
    fill: "#E6F0F0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9999 89.458H29.6023C28.3447 89.458 27.3252 90.4775 27.3252 91.7351C27.3252 92.9927 28.3447 94.0122 29.6023 94.0122H62.9999C64.2575 94.0122 65.277 92.9927 65.277 91.7351C65.277 90.4775 64.2575 89.458 62.9999 89.458Z",
    fill: "#B3D1D1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3372 100.084H29.6023C28.3447 100.084 27.3252 101.104 27.3252 102.362C27.3252 103.619 28.3447 104.639 29.6023 104.639H49.3372C50.5949 104.639 51.6144 103.619 51.6144 102.362C51.6144 101.104 50.5949 100.084 49.3372 100.084Z",
    fill: "#E6F0F0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9999 109.952H29.6023C28.3447 109.952 27.3252 110.972 27.3252 112.229C27.3252 113.487 28.3447 114.506 29.6023 114.506H62.9999C64.2575 114.506 65.277 113.487 65.277 112.229C65.277 110.972 64.2575 109.952 62.9999 109.952Z",
    fill: "#B3D1D1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_314_10786)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.5664 9H24.2893C22.1933 9 20.4941 10.6992 20.4941 12.7952V35.5663C20.4941 37.6623 22.1933 39.3614 24.2893 39.3614H89.5664C91.6624 39.3614 93.3616 37.6623 93.3616 35.5663V12.7952C93.3616 10.6992 91.6624 9 89.5664 9Z",
    fill: "#B3D1D1"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3377 17.3496H29.6028C28.3452 17.3496 27.3257 18.3691 27.3257 19.6267C27.3257 20.8843 28.3452 21.9038 29.6028 21.9038H49.3377C50.5953 21.9038 51.6148 20.8843 51.6148 19.6267C51.6148 18.3691 50.5953 17.3496 49.3377 17.3496Z",
    fill: "#E6F0F0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0004 27.2173H29.6028C28.3452 27.2173 27.3257 28.2368 27.3257 29.4944C27.3257 30.752 28.3452 31.7715 29.6028 31.7715H63.0004C64.258 31.7715 65.2775 30.752 65.2775 29.4944C65.2775 28.2368 64.258 27.2173 63.0004 27.2173Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_314_10786",
    x: 14.4941,
    y: 38.7109,
    width: 84.8677,
    height: 99.2891,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.788235 0 0 0 0 0.803922 0 0 0 0 0.85098 0 0 0 0.349 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_314_10786"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_314_10786",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_314_10786",
    x: 14.4941,
    y: 0,
    width: 84.8677,
    height: 42.3613,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.788235 0 0 0 0 0.803922 0 0 0 0 0.85098 0 0 0 0.349 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_314_10786"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_314_10786",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoTemplate);
export default __webpack_public_path__ + "static/media/no-template.b8ed74850d4199357455b83a6c6956fd.svg";
export { ForwardRef as ReactComponent };